import { useEffect, useState } from 'react'
import { getRentRegisterApi } from '../api/api.js'
import Pagination from '../components/ui/Pagination.jsx'
import { usePagination } from '../hooks/usePagination.js'

export default function RentRegister() {
  const [limit] = useState(30)
  const [total, setTotal] = useState(0)
  const pagination = usePagination(total, limit)

  const [rows, setRows] = useState([])
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    const params = {
      page: pagination.currentPage,
      limit,
    }
    getRentRegisterApi(params)
      .then((res) => {
        const payload = res.data?.data ?? res.data
        const list = Array.isArray(payload) ? payload : (payload?.rows ?? [])
        setRows(list)
        setTotal(res.data?.totalCount ?? 0)
      })
      .catch(() => {
        setRows([])
        setTotal(0)
      })
      .finally(() => setLoading(false))
  }, [pagination.currentPage, limit])

  return (
    <div className="card">
      <h2>Rent Register</h2>
      {loading ? (
        'Loading...'
      ) : (
        <div className="table-wrap" style={{ overflowX: 'visible', width: '100%' }}>
          <table className="table table-striped" style={{ width: '100%', minWidth: 'unset', tableLayout: 'auto' }}>
            <thead>
              <tr>
                <th style={{ width: '33%' }}>Party Name</th>
                <th style={{ width: '33%' }}>Product Name</th>
                <th style={{ textAlign: 'right', width: '34%' }}>Rent</th>
              </tr>
            </thead>
            <tbody>
              {rows.length === 0 ? (
                <tr>
                  <td colSpan="3" style={{ textAlign: 'center', padding: '2rem', color: '#546e7a' }}>
                    No records available
                  </td>
                </tr>
              ) : (
                rows.map((r, idx) => (
                  <tr key={r.id || idx}>
                    <td style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>{r.partyName}</td>
                    <td style={{ wordWrap: 'break-word', whiteSpace: 'normal' }}>{r.productName}</td>
                    <td style={{ textAlign: 'right', wordWrap: 'break-word', whiteSpace: 'normal' }}>
                      {Number(r.rent) != null ? Number(r.rent).toFixed(2) : '—'}
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
          {!loading && total > 0 && (
            <Pagination
              currentPage={pagination.currentPage}
              totalPages={pagination.totalPages}
              onPageChange={pagination.goToPage}
            />
          )}
        </div>
      )}
    </div>
  )
}
